import * as turf from "@turf/turf";
import { useEffect, useMemo } from "react";
import { useMap } from "react-map-gl";
import { useMapStore, useViewSettingsStore } from "..";
import Shape from "../interfaces/Shape";
import GeometryService from "../services/geometryService";
import { InitiatorType } from "./useFlyTo";

export default function (shape: Shape, initiatorType: InitiatorType) {
    const map = useMap().map!;
    const mapStore = useMapStore();
    const viewSettingsStore = useViewSettingsStore();
    const geometryService = useMemo(() => new GeometryService(), []);
    const feature = useMemo(() => shape && geometryService.mapIShapesToPolygonFeatures([shape])[0], [shape]);

    useEffect(() => {
        if (!feature) return;

        if ((viewSettingsStore.isMobile && initiatorType === InitiatorType.Details) || (!viewSettingsStore.isMobile && initiatorType === InitiatorType.Popup)) {
            const reducedMotion = !!window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
            setTimeout(() => {
                const [minX, minY, maxX, maxY] = turf.bbox(feature);
                map.fitBounds([[minX, minY], [maxX, maxY]], { padding: 32 });
                if (reducedMotion) {
                    setTimeout(() => {
                        const center = map.getCenter();
                        mapStore.setViewState({
                            longitude: center.lng,
                            latitude: center.lat,
                            zoom: map.getZoom(),
                        });
                    }, 0);
                }
            }, 10);
        }
    }, [feature]);
}

export function useGeoJSONFitBound(geojson?: turf.helpers.AllGeoJSON) {
    const map = useMap().map!;
    const mapStore = useMapStore();

    useEffect(() => {
        if (!geojson) return;
        const reducedMotion = !!window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
        setTimeout(() => {
            const [minX, minY, maxX, maxY] = turf.bbox(geojson);
            map.fitBounds([[minX, minY], [maxX, maxY]], { padding: 32 });
            if (reducedMotion) {
                setTimeout(() => {
                    const center = map.getCenter();
                    mapStore.setViewState({
                        longitude: center.lng,
                        latitude: center.lat,
                        zoom: map.getZoom(),
                    });
                }, 0);
            }
        });

    }, [geojson]);
}
